import { render } from "./BaseCreateContact.vue?vue&type=template&id=021da720"
import script from "./BaseCreateContact.vue?vue&type=script&lang=js"
export * from "./BaseCreateContact.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__